import React from 'react'
import {Button, Card, CardBody, Col, Form, FormGroup, Input, Row} from "reactstrap";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import {common_strings} from "../../translations/common_translations";
import resourceHelper from "../../helpers/ResourceHelper";
import Select from "react-select";
import localeHelpers from "../../helpers/LocaleHelper";
import categoryHelpers from "../../helpers/CategotyHelper";
import paymentTypeHelpers from "../../helpers/PaymentTypeHelper";
import businessHelper from "../../helpers/BusinessHelper";
import dateHelpers from "../../helpers/DateHelper";
import businessApiService from "../../api/business-api-service";

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const propTypes = {};

class EditInvoiceSettingsView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            inputsUpdated: true,
            business: businessHelper.business()
        };
    }

    handleChange = this.handleChange.bind(this);

    handleChange(event) {

        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "input-name":
                this.setState(prevState => ({
                    business: {
                        ...prevState.business,
                        i_name: newValue
                    }
                }));
                break;
            case "input-address":
                this.setState(prevState => ({
                    business: {
                        ...prevState.business,
                        i_address: newValue
                    }
                }));
                break;
            case "input-email":
                this.setState(prevState => ({
                    business: {
                        ...prevState.business,
                        i_email: newValue
                    }
                }));
                break;
            case "input-phone":
                this.setState(prevState => ({
                    business: {
                        ...prevState.business,
                        i_phone: newValue
                    }
                }));
                break;
            case "input-pd":
                this.setState(prevState => ({
                    business: {
                        ...prevState.business,
                        i_pd: newValue
                    }
                }));
                break;
            case "input-reg":
                this.setState(prevState => ({
                    business: {
                        ...prevState.business,
                        i_reg_id: newValue
                    }
                }));
                break;
            case "input-tax":
                const updatedPrice = parseFloat(newValue.replace(/,/g, '-.'));
                this.setState(prevState => ({
                    business: {
                        ...prevState.business,
                        i_tax: updatedPrice
                    }
                }));

                break;
            case "input-prefix":
                this.setState(prevState => ({
                    business: {
                        ...prevState.business,
                        i_prefix: newValue
                    }
                }));

                break;
            case "input-number":
                this.setState(prevState => ({
                    business: {
                        ...prevState.business,
                        i_number: newValue
                    }
                }));

                break;
            default:
                return
        }
    }

    render() {
        this.localize();

        return (
            <Card className="bg-secondary shadow">
                <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                        <div className="pl-lg-4">

                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-name"
                                        >
                                            {commonStrings.business.name}
                                        </label>
                                        <Input
                                            placeholder={commonStrings.business.name}
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            value={this.state.business.i_name || ""}
                                            id="input-name"
                                            type="text"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-address"
                                        >
                                            {commonStrings.address}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            value={this.state.business.i_address || ""}
                                            id="input-address"
                                            type="address"
                                            placeholder={commonStrings.address}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-email"
                                        >
                                            {commonStrings.email}
                                        </label>
                                        <Input
                                            placeholder={commonStrings.email}
                                            className="form-control-alternative"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.business.i_email}
                                            id="input-email"
                                            type="email"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-phone"
                                        >
                                            {commonStrings.phone}
                                        </label>
                                        <Input
                                            placeholder={commonStrings.phone}
                                            className="form-control-alternative"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.business.i_phone}
                                            id="input-phone"
                                            type="tel"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-pd"
                                        >
                                            {resourceStrings.invoices.payment_info}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.business.i_pd}
                                            id="input-pd"
                                            type="text"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-reg"
                                        >
                                            {resourceStrings.invoices.company_id}
                                        </label>
                                        <Input
                                            placeholder={resourceStrings.invoices.company_id}
                                            className="form-control-alternative"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.business.i_reg_id}
                                            id="input-reg"
                                            type="text"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-tax"
                                        >
                                            {resourceStrings.invoices.tax_rate}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.getTax()}
                                            id="input-tax"
                                            type="number"
                                            pattern="^\d+(?:\.\d{1,2})?$"
                                            placeholder="0.00"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-prefix"
                                        >
                                            {resourceStrings.invoices.invoice_number_prefix}
                                        </label>
                                        <Input
                                            placeholder={resourceStrings.invoices.invoice_number_prefix}
                                            className="form-control-alternative"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.business.i_prefix}
                                            id="input-prefix"
                                            type="text"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-number"
                                        >
                                            {resourceStrings.invoices.invoice_number}
                                        </label>
                                        <Input
                                            placeholder={resourceStrings.invoices.invoice_number}
                                            className="form-control-alternative"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.business.i_number}
                                            id="input-number"
                                            type="number"
                                            min="0"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                        </div>

                        <Row>
                            <Col lg="12">
                                <Col className="text-right">
                                    <Button
                                        color="warning"
                                        outline="button"
                                        size="lg"
                                        onClick={e => this.props.closeEditInvoiceSettingsView(e)}
                                    >
                                        {commonStrings.close}
                                    </Button>

                                    <Button
                                        color="default"
                                        size="lg"
                                        onClick={e => this.updateInvoiceSettings(e)}
                                    >
                                        {commonStrings.save}
                                    </Button>
                                </Col>
                            </Col>
                        </Row>

                    </Form>
                </CardBody>
            </Card>
        )
    }

    updateInvoiceSettings(e) {
        e.preventDefault();

        const data = {
            i_name: this.state.business.i_name,
            i_address: this.state.business.i_address,
            i_email: this.state.business.i_email,
            i_phone: this.state.business.i_phone,
            i_pd: this.state.business.i_pd,
            i_tax: this.state.business.i_tax,
            i_number: this.state.business.i_number,
            i_prefix: this.state.business.i_prefix,
            i_reg_id: this.state.business.i_reg_id,
        };

        businessApiService.update(data)
            .then(res => {
                businessHelper.saveBusiness(res.user);
                businessHelper.saveSubUser(res.current);
                this.props.closeEditInvoiceSettingsView()
            })
            .catch((error) => {
                this.props.handleError(error)
            });
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    getTax() {
        return parseFloat(this.state.business.i_tax)
    }
}

EditInvoiceSettingsView.propTypes = propTypes;

export default EditInvoiceSettingsView;